import mutations from './projectMutations';
import actions from './projectActions';
import getters from './projectGetters';

const state = {
  projectComboList: [],
  projectList: [],

  /* Main state * */
  userProjectList: [],
  projectDetail: [],
  projectCspList: [],
  projectEnvs: [],
  envTab: '',
  resourceUserList: [],
  /* 좌측 프로젝트 목록 페이징 처리를 위한 값 * */
  currentPage: 1,
  pageSize: 10,
  pageUnit: 10,
  records: 0,

  /* 우측 유저 목록 페이징 처리를 위한 값 * */
  userCurrentPage: 1,
  userPageSize: 10,
  userPageUnit: 10,
  userRecords: 0,

  /* Popup state * */
  serviceMembersList: [],
  allUserList: [],
};

export default {
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/vuex/rem/project/projectStore.js